export default __webpack_public_path__ + "static/media/help.ffa3fb15.svg";